/* Account favorites. No customer IDs, access tokens or saved lists in storage. */
(function () {
  'use strict';
  var doc = document;
  function mount() {
    var source = doc.getElementById('J4UFavoritesConfig');
    if (!source) return;
    var config = JSON.parse(source.textContent);
    var endpoint = new URL(config.proxyPath, location.origin);
    if (endpoint.origin !== location.origin || !endpoint.pathname.includes('/apps/')) return;
    // Server-confirmed values stay separate from the latest click for each product.
    // One write at a time preserves registration order without locking the UI.
    var selected = new Set(), pending = new Map(), csrf = '', ready = false, guest = false, saving = false, lastRead = 0, reading, navigation;
    var message = doc.getElementById('J4UFavoritesMessage'), messageTimer;
    function show(text, login, temporary) {
      clearTimeout(messageTimer);
      message.replaceChildren();
      message.appendChild(doc.createTextNode(text));
      if (login) {
        var link = doc.createElement('a');
        var url = new URL(config.loginURL, location.origin);
        url.searchParams.set('return_url', location.pathname + location.search);
        link.href = url.href; link.textContent = ' Sign in'; message.appendChild(link);
      }
      message.hidden = false;
      if (temporary) messageTimer = setTimeout(function () { message.hidden = true; }, 5000);
    }
    function paint() {
      doc.querySelectorAll('[data-j4u-favorite]').forEach(function (button) {
        var id = button.dataset.j4uFavorite;
        var waiting = pending.has(id);
        var saved = waiting ? pending.get(id) : selected.has(id);
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('aria-label', (saved ? 'Remove from favorites: ' : 'Add to favorites: ') + (button.dataset.favoriteTitle || 'product'));
        button.title = saved ? 'Remove from favorites' : 'Add to favorites';
        button.disabled = false;
        button.toggleAttribute('data-favorite-pending', waiting);
        button.setAttribute('aria-busy', String(waiting));
        var label = button.querySelector('[data-favorite-label]');
        if (label) label.textContent = waiting ? 'Saving…' : saved ? 'Saved to favorites' : 'Add to favorites';
      });
    }
    function cards() {
      doc.querySelectorAll('.j4u-product[data-product-id]').forEach(function (card) {
        if (card.querySelector('[data-j4u-favorite]')) return;
        var button = doc.createElement('button');
        button.type = 'button'; button.className = 'j4u-favorite-button j4u-favorite-card';
        button.dataset.j4uFavorite = card.dataset.productId;
        button.dataset.favoriteTitle = card.querySelector('.product__title')?.textContent || 'product';
        var icon = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('data-favorite-star', ''); icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('aria-hidden', 'true'); icon.setAttribute('focusable', 'false');
        var path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'm12 3 2.78 5.63 6.22.91-4.5 4.39 1.06 6.2L12 17.2l-5.56 2.93 1.06-6.2L3 9.54l6.22-.91Z'); icon.appendChild(path);
        button.appendChild(icon); card.appendChild(button);
      });
      paint();
    }
    async function request(options) {
      var response = await fetch(endpoint.href, Object.assign({credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(20000)}, options));
      var data;
      try { data = await response.json(); } catch (_) { throw new Error('Favorites are temporarily unavailable. Please try again.'); }
      if (!response.ok) {
        var error = new Error(data.error || 'Favorites could not be saved. Please try again.');
        error.status = response.status; throw error;
      }
      if (!Array.isArray(data.items) || typeof data.csrf !== 'string') throw new Error('Favorites are temporarily unavailable. Please try again.');
      return data;
    }
    function accept(data) {
      var confirmed = new Set(data.items.map(function (item) { return item.productId; }));
      // A click made before the initial read means toggle the actual server state.
      if (!ready) pending.forEach(function (wanted, id) {
        pending.set(id, wanted !== selected.has(id) ? !confirmed.has(id) : confirmed.has(id));
      });
      guest = false; ready = true; csrf = data.csrf;
      selected = confirmed;
      lastRead = Date.now(); paint();
    }
    async function refresh() {
      if (reading) return reading;
      reading = request().then(accept).catch(function (error) {
        if (error.status === 401 || error.status === 403) {
          guest = error.status === 401; ready = false; csrf = ''; selected.clear(); paint();
        }
        throw error;
      }).finally(function () { reading = null; });
      return reading;
    }

    async function savePending() {
      if (saving) return;
      saving = true;
      try {
        if (reading) await reading;
        // Reuse the customer-bound CSRF token, issued for one hour. A changed
        // account is rejected by the server; never replay that click as another user.
        if (!ready || Date.now() - lastRead > 45 * 60 * 1000) await refresh();
        while (pending.size) {
          var entry = pending.entries().next().value;
          var id = entry[0], wanted = entry[1];
          if (selected.has(id) === wanted) { pending.delete(id); paint(); continue; }
          var data = await request({method: 'POST', keepalive: true, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({operation: wanted ? 'add' : 'remove', productId: id, csrf: csrf})});
          accept(data);
          // The same star may have been clicked again while this write was pending.
          if (pending.get(id) === selected.has(id)) pending.delete(id);
          paint();
        }
        show('Favorites saved.', false, true);
        if (navigation) { var destination = navigation; navigation = null; location.assign(destination); }
      } catch (error) {
        pending.clear(); navigation = null; ready = false;
        if (error.status === 401 || error.status === 403) {
          guest = error.status === 401; csrf = ''; selected.clear();
        }
        paint();
        show(error.status === 401 ? 'Sign in to save favorites to your account.' : error.message + ' Unsaved changes have been cancelled.', error.status === 401);
        // A timed-out write may have reached the server. Reconcile, without
        // retrying cancelled edits or hiding the error message.
        refresh().catch(function () {});
      } finally { saving = false; paint(); }
    }
    doc.addEventListener('click', function (event) {
      var button = event.target.closest('[data-j4u-favorite]');
      if (!button) return;
      event.preventDefault();
      if (guest) { show('Sign in to save favorites to your account.', true); return; }
      var id = button.dataset.j4uFavorite;
      pending.set(id, !(pending.has(id) ? pending.get(id) : selected.has(id)));
      paint(); show('Saving favorites…');
      void savePending();
    });
    // Let queued saves finish before following a normal link. Other-tab links
    // can open immediately because this page remains alive to finish its queue.
    doc.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!pending.size || !link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.download || (link.target && link.target !== '_self')) return;
      var url = new URL(link.href, location.href);
      if (!/^https?:$/.test(url.protocol) || (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash)) return;
      event.preventDefault(); navigation = url.href;
      show('Saving favorites before opening the next page…');
    }, true);
    window.addEventListener('beforeunload', function (event) {
      if (!pending.size) return;
      event.preventDefault(); event.returnValue = '';
    });
    doc.addEventListener('j4u:products-rendered', cards);
    function resume() { if (!saving && !pending.size && doc.visibilityState !== 'hidden' && (!ready || Date.now() - lastRead > 1000)) refresh().catch(function () {}); }
    window.addEventListener('pageshow', resume);
    window.addEventListener('focus', resume);
    doc.addEventListener('visibilitychange', resume);
    cards(); refresh().catch(function () {});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
